import { autoinject } from "aurelia-dependency-injection";
import { ValueConverter } from "aurelia-binding";
import {
  BindingSignaler,
  SignalBindingBehavior,
} from "aurelia-templating-resources";

export class JsonValueConverter {
  toView(value: any): string {
    return JSON.stringify(value, null, "  ");
  }
}

@autoinject
export class JsonBindingBehavior {
  private interval: number;

  constructor(
    private signaler: BindingSignaler,
    private signalBindingBehavior: SignalBindingBehavior,
  ) {}

  bind(binding?: any, scope?: any) {
    // bind the signal behavior
    (this.signalBindingBehavior as any).bind(binding, scope, "update-json");

    // rewrite the expression to use the JsonValueConverter.
    // pass through any args to the binding behavior to the JsonValueConverter
    let sourceExpression = binding.sourceExpression;

    // do create the sourceExpression only once
    if (sourceExpression.rewritten) {
      return;
    }
    sourceExpression.rewritten = true;

    let expression = sourceExpression.expression;
    sourceExpression.expression = new ValueConverter(
      expression,
      "json",
      sourceExpression.args,
      [expression, ...sourceExpression.args],
    );

    this.interval = window.setInterval(
      () => this.signaler.signal("update-json"),
      150,
    );
  }

  unbind(binding?: any, scope?: any) {
    window.clearInterval(this.interval);
    this.signalBindingBehavior.unbind(binding, scope);
  }
}
